import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FilterPanelEditorConfigurationModel } from 'src/ca-shared/filter-panel/models/filter-panel-editor-configuration.model';
import { FilterPanelEditorComponent } from 'src/ca-shared/filter-panel/models/filter-panel-editor.component';
import { CustomerLanguageDto } from 'src/core/models/virtual-translator/customer-language.dto';
import { CustomerLanguageService } from 'src/core/services/vt/customer-language.service';
import { CustomerLanguageSelectionConfigurationModel } from '../models/customer-language-selection-configuration.model';

@Component({
  selector: 'ca-customer-language-selection-panel',
  templateUrl: './customer-language-selection-panel.component.html',
  styleUrls: ['./customer-language-selection-panel.component.scss'],
  standalone: false,
})
export class CustomerLanguageSelectionPanelComponent
  extends FilterPanelEditorComponent
  implements OnInit, OnDestroy
{
  actualConfig: CustomerLanguageSelectionConfigurationModel;

  private destroy$ = new Subject<void>();

  allLanguages: CustomerLanguageDto[] = [];
  pagedLanguages: CustomerLanguageDto[] = [];
  totalCount = 0;
  pageSize = 5;
  currentPage = 1;

  _value: string[] = [];

  set config(value: FilterPanelEditorConfigurationModel) {
    this.actualConfig = value as CustomerLanguageSelectionConfigurationModel;
  }

  get config(): FilterPanelEditorConfigurationModel {
    return this.actualConfig;
  }

  set value(value: any) {
    this._value = Array.isArray(value) ? value : [];
    this.editorForm.patchValue({
      editor: this._value,
    });
  }

  get value(): any {
    return this._value;
  }

  constructor(
    protected fb: FormBuilder,
    private customerLanguageService: CustomerLanguageService,
  ) {
    super(fb);
  }

  ngOnInit(): void {
    this.pageSize = this.actualConfig.pageSize ?? 5;
  }

  init(): void {
    super.init();
    if (this.actualConfig.autoLoad) {
      this.load();
    }
  }

  private load(): void {
    this.customerLanguageService
      .getCustomerLanguages()
      .pipe(takeUntil(this.destroy$))
      .subscribe(items => {
        this.allLanguages = items ?? [];
        this.totalCount = this.allLanguages.length;
        this.slice();
      });
  }

  private slice(): void {
    const start = (this.currentPage - 1) * this.pageSize;
    this.pagedLanguages = this.allLanguages.slice(start, start + this.pageSize);
  }

  onPageChange(eventArgs: PageEvent): void {
    this.currentPage = eventArgs.pageIndex + 1;
    this.slice();
  }

  isChecked(item: CustomerLanguageDto): boolean {
    return this._value.indexOf(item.code) > -1;
  }

  onCheckChanged(eventArgs, item: CustomerLanguageDto): void {
    const checked = eventArgs.currentTarget.checked;
    const idx = this._value.indexOf(item.code);

    if (checked) {
      if (idx < 0) {
        this._value.push(item.code);
      }
    } else {
      if (idx > -1) {
        this._value.splice(idx, 1);
      }
    }

    this.editorForm.patchValue({
      editor: this._value,
    });

    this.onChange();
  }

  reload(): void {
    this.load();
  }

  reset(): void {
    this.currentPage = 1;
    this.value = [];
    this.slice();
  }

  autoSelectFirstItem(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
